const preloader = () => {
  const preloader = document.getElementById('preloader');
  const heroSections = document.querySelectorAll('.hero');

  heroSections.forEach(item => item.classList.add('show'));

  preloader.classList.add('hidden');
  document.body.classList.remove('with-preloader');

  setTimeout(() => {
    preloader.remove();
  }, 1000);
}

export default preloader;
